import { baseApi } from '@shared/api/baseApi'
import type {
  NpsFeaturesResponse,
  NpsRefusalRequest,
  NpsRefusalResponse,
  NpsReviewRequest,
  NpsReviewResponse,
} from '../types'

export const fetchNpsFeatures = async (): Promise<NpsFeaturesResponse> => {
  const { data } = await baseApi.get<NpsFeaturesResponse>('/api/nps/features')
  return data
}

export const sendNpsReview = async (
  body: NpsReviewRequest
): Promise<NpsReviewResponse> => {
  // page и text отправляем всегда: null бэк не принимает, а пропуск поля
  // обесценивает разрез по экранам в отчётах.
  const { data } = await baseApi.post<NpsReviewResponse>('/api/nps/review', {
    text: '',
    page: '',
    ...body,
  })
  return data
}

export const sendNpsRefusal = async (
  body: NpsRefusalRequest
): Promise<NpsRefusalResponse> => {
  const { data } = await baseApi.post<NpsRefusalResponse>('/api/nps/refuse', body)
  return data
}
